import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {API_BASE_URL} from '../../config';
import '../../assets/css/Customer.css';
import {useParams} from "react-router-dom";

const SectionTechniqueDetailsResume = ({toggle}) => {
    const [data, setData] = useState([]);
    const {id} = useParams();
    const customerId = parseInt(id);

    useEffect(() => {
        axios
            .post(`${API_BASE_URL}/get_customer_all_technical_data/`, {customer_id: customerId})
            .then((res) => {
                setData(res.data.result);
            })
            .catch((err) => console.error(err));
    }, [customerId]);

    return (<div className="customer-view-main-container">
        <div className="display-flex flex-direction-column gap-20">
            <h3 className={"color-third"}>Aperçu</h3>
            <div className={"h-separator"}/>
            <div className="customer-view-container display-flex gap-20 flexwrap-wrap">
                <div
                    onClick={toggle}
                    className="customer-view-detail display-flex justify-content-space-between align-items-center flex-direction-column p-10 border-radius-10 flex-1"
                    style={{minHeight: 140, border: "solid 2px #ddd"}}>
                    <span className="customer-view-label text-center">Prestataire de mails actuels</span>
                    <span
                        className=" customer-view-value display-flex align-items-center justify-content-center"
                        style={{
                            border:`solid 2px ${(data[0]?.customer_email_org_id ) ? "lightblue" : "orange"}`,
                            backgroundColor: ( data[0]?.customer_email_org_id ) ? "aqua" : "#FFE2C6",
                            height: 35,
                            borderRadius: 5,
                            width: "100%"
                        }}
                    >
                        {data[0]?.customer_email_org_id === 10 ? (
                            <span className="text-center">Autre</span>
                        ) : (data[0]?.customer_email_org_id === null || data[0]?.customer_email_org_id === undefined || data[0]?.customer_email_org_id === 0 ) ? (
                            <span className="text-center" style={{ color: "orangered", fontWeight: 700, fontSize: 13 }}>
                                Non renseigné
                            </span>
                        ) : (
                            <img
                                src={`https://x.solution-digitale.ch/assets/customers/orgs/${data[0]?.email_org_name}.png`}
                                style={{ height: 35, objectFit: 'contain' }}
                                alt="Email provider logo"
                            />
                        )}
                    </span>
                </div>
                <div
                    className="customer-view-detail display-flex justify-content-space-between align-items-center flex-direction-column p-10 border-radius-10 flex-1"
                    style={{minHeight: 140, border: "solid 2px #ddd"}}>

                    <span className="customer-view-label text-center">Hébergeur web</span>
                    <span
                        className="customer-view-value  display-flex align-items-center justify-content-center"
                        style={{

                            border:`solid 2px ${(data[0]?.customer_provider ) ? "lightblue" : "orange"}`,
                            backgroundColor: ( data[0]?.customer_provider ) ? "aqua" : "#FFE2C6",

                            height: 35,
                            width: "100%",
                            borderRadius: 5,
                            fontWeight: 700,
                            fontSize: 13
                        }}>

                                {data[0]?.customer_provider ?
                                    <span className="text-center" style={{color: "#06c"}}>{data[0]?.customer_provider}</span> :
                                    <span className="text-center" style={{
                                        color: "orangered",
                                        fontWeight: 700,
                                        fontSize: 13
                                    }}>Non renseigné</span>}

                        </span>
                </div>
                <div
                    className="customer-view-detail display-flex justify-content-space-between align-items-center flex-direction-column p-10 border-radius-10 flex-1"
                    style={{minHeight: 140, border: "solid 2px #ddd"}}>

                    <span className="customer-view-label text-center">Zone DNS</span>
                    <span
                        className="customer-view-value display-flex align-items-center justify-content-center"
                        style={{


                            border:`solid 2px ${(data[0]?.dns_zone && data[0]?.dns_zone.length > 0 ) ? "lightblue" : "orange"}`,
                            backgroundColor: ( data[0]?.dns_zone && data[0]?.dns_zone.length > 0 ) ? "aqua" : "#FFE2C6",

                            height: 35,
                            borderRadius: 5,
                            width: "100%"
                        }}>

                                {data[0]?.dns_zone && data[0]?.dns_zone.length > 0 ?
                                    <span className="text-center">
                                        <i style={{color: "#06c"}} className="fas fa-check"/>
                                    </span>
                                    :
                                    <span className="text-center" style={{
                                        color: "orangered",
                                        fontWeight: 700,
                                        fontSize: 13
                                    }}>Non renseigné</span>
                                }

                        </span>
                </div>
                <div
                    className="customer-view-detail display-flex justify-content-space-between align-items-center flex-direction-column p-10 border-radius-10 flex-1"
                    style={{minHeight: 140, border: "solid 2px #ddd"}}>

                    <span className="customer-view-label text-center">Domaine</span>
                    <span
                        className="customer-view-value display-flex align-items-center justify-content-center"
                        style={{
                            border:`solid 2px ${(data[0]?.domain_name && parseInt(data[0]?.domain_name) !== 0 ) ? "lightblue" : "orange"}`,
                            backgroundColor: ( data[0]?.domain_name && parseInt(data[0]?.domain_name) !== 0 ) ? "aqua" : "#FFE2C6",
                            height: 35,
                            borderRadius: 5,
                            width: "100%"
                        }}
                    >
                        {
                            data[0]?.domain_name === "4" ? (
                                <span className="text-center display-flex gap-10 align-items-center p-10">
                                    <span className="text-center" style={{color: "#06c", fontWeight: 700, fontSize: 13}}>Acheté par SD</span>
                                </span>
                            ) : (data[0]?.domain_name === "1" ? (
                                <span className="text-center display-flex gap-10 align-items-center p-10">
                                    <span className="text-center" style={{color: "#06c", fontWeight: 700, fontSize: 13}}>En notre possession</span>
                                </span>
                            ) : (data[0]?.domain_name === "2" ? (
                                <span className="text-center display-flex gap-10 align-items-center p-10">
                                    <span className="text-center" style={{color: "#06c", fontWeight: 700, fontSize: 13}}>À acheter</span>
                                </span>
                            ): (data[0]?.domain_name === "3" ? (
                                <span className="text-center display-flex gap-10 align-items-center p-10">
                                    <span className="text-center" style={{color: "#06c", fontWeight: 700, fontSize: 13}}>À récupérer</span>
                                </span>
                            ) : (
                                <span className="text-center" style={{color: "orangered", fontWeight: 700, fontSize: 13}}>
                                    Non renseigné
                                </span>
                                )
                            )
                            )
                            )
                        }
                    </span>
                </div>
            </div>
            <div className={"h-separator"}></div>
            <div
                className="customer-view-container display-flex flex-direction-column gap-20">
                <div className="customer-view-detail display-flex flex-direction-column">
                    <h3 className="color-third mb-20">Contact technique</h3>

                    <span className="customer-view-value display-flex flex-direction-column gap-10">
                            <div className="display-flex gap-20">
                                <i className="fas fa-user color-third"/>
                                <div className={"display-flex gap-5"}>
                                {data[0]?.firstname && <span>{data[0]?.firstname}</span>}
                                    {data[0]?.name && <span>{data[0]?.name}</span>}</div>
                            </div>
                        {data[0]?.mail && (<div className="display-flex gap-20">
                            <i className="fas fa-envelope color-third"/>
                            <span>{data[0]?.mail}</span>
                        </div>)}
                        {data[0]?.phone && (<div className="display-flex gap-20">
                            <i className="fas fa-phone color-third"/>
                            <span>{data[0]?.phone}</span>
                        </div>)}
                        {data[0]?.factory && (<div className="display-flex gap-20">
                            <i className="fas fa-building color-third"/>
                            <span>{data[0]?.factory}</span>
                        </div>)}
                        </span>
                </div>
            </div>
        </div>
    </div>);
};

export default SectionTechniqueDetailsResume;
